import React, { useRef, useEffect, useState } from 'react';
import classnames from 'classnames';
import './form_switcher.css';
import { FormField } from '../../../model/form';

interface Props extends FormField<boolean> {
  label?: string;
  labels?: string[];
  size?: 'small' | 'medium';
}

export function FormSwitcher({ id, value, label, onChange, labels, disabled, size = 'medium' }: Props): JSX.Element {
  const [style, setStyle] = useState({
    transform: 'translateX(0)',
    width: 0,
  });
  const onRef = useRef<HTMLDivElement | null>(null);
  const offRef = useRef<HTMLDivElement | null>(null);

  function handleOnChange(v: boolean): void {
    if (onChange) {
      onChange(v);
    }
  }

  function calcStyle(): void {
    if (onRef && onRef.current && offRef && offRef.current) {
      if (value) {
        setStyle({
          transform: `translateX(${onRef.current.offsetLeft}px)`,
          width: onRef.current.clientWidth,
        });
      } else {
        setStyle({
          transform: `translateX(${offRef.current.offsetLeft}px)`,
          width: offRef.current.clientWidth,
        });
      }
    }
  }

  useEffect(() => {
    calcStyle();
  }, [value]);

  return (
    <div
      id={id}
      className={classnames('form-switcher', `form-switcher--${size}`, {
        'form-switcher--disabled': disabled,
      })}
    >
      {label && (
        <label className="form-switcher__label" htmlFor={id}>
          {label}
        </label>
      )}
      <div className="form-switcher__wrapper" id={id}>
        <div className="form-switcher__pill" style={style} />
        <div
          ref={onRef}
          className={classnames('form-switcher__option', {
            'form-switcher__option--active': value,
          })}
          onClick={() => {
            handleOnChange(true);
          }}
        >
          {(labels && labels[0]) || 'ON'}
        </div>
        <div
          ref={offRef}
          className={classnames('form-switcher__option', {
            'form-switcher__option--active': !value,
          })}
          onClick={() => {
            handleOnChange(false);
          }}
        >
          {(labels && labels[1]) || 'OFF'}
        </div>
      </div>
    </div>
  );
}
